import type { Translations } from "../types";

const sl: Translations = {
  "meta.title": "Kliki po državah na zemljevidu",
  "meta.description":
    "Interaktivni zemljevid sveta: brezplačni kliki za vsako državo ter plačana podpora prek Stripe, PayPal in Buy Me a Coffee.",

  "app.title": "Kliki po državah na zemljevidu",

  "map.intro":
    "Klikni na državo na zemljevidu, da ji podariš brezplačen glas, ali ji pošlji finančno podporo - oboje šteje za skupno lestvico spodaj. Zemljevid odraža samo podporo znotraj te aplikacije, ne dejanskega nacionalnega bogastva ali BDP.",
  "map.verifying": "Preverjanje …",
  "map.confirmNotRobot": "Preden lahko dodajaš brezplačne klike, hitro potrdi, da nisi robot:",
  "map.tryAgain": "Poskusi znova",
  "map.registeringClick": "Beleženje klika …",
  "map.selectedCountry": "Izbrana država: {name}.",
  "map.selectFirstFeedback": "Država je izbrana. Za brezplačen klik najprej spodaj potrdi, da nisi robot.",
  "map.verificationExpired": "Potrditev je potekla - znova potrdi, da nisi robot.",
  "map.slowDown": "Malo počasneje - pred naslednjim klikom malo počakaj.",
  "map.clickFailed": "Klika ni bilo mogoče zabeležiti. Poskusi znova.",
  "map.clickErrorGeneric": "Napaka pri beleženju klika.",
  "map.leaderboardHeading": "Lestvica držav",
  "map.emptySelection": "Izberi državo na zemljevidu, da ji podariš klik ali jo podpreš.",
  "map.loadingData": "Nalaganje podatkov …",

  "worldmap.loadError": "Zemljevida ni bilo mogoče naložiti.",
  "worldmap.resetZoom": "Ponastavi približanje",
  "worldmap.resetButton": "⤾ Ponastavi",
  "worldmap.loadingMap": "Nalaganje zemljevida …",
  "worldmap.unknownCountry": "Neznano",
  "worldmap.ariaClicks": "{name}: {clicks} klikov",
  "worldmap.tooltipClicks": "{clicks} klikov",

  "legend.fewer": "Manj klikov",
  "legend.more": "Več klikov",

  "list.empty": "Še ni klikov. Bodi prvi!",
  "list.ariaLabel": "Lestvica držav po klikih",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY ni nastavljen - za nastavitev glej README.",
  "human.verificationFailedGeneric": "Preverjanje ni uspelo.",
  "human.networkError":
    "Preverjanja ni bilo mogoče doseči (napaka omrežja) - preveri VITE_SUPABASE_URL, ali je verify-human objavljen, in ALLOWED_ORIGIN; glej README/NAVODILA.",
  "human.verificationFailedRetry": "Preverjanje ni uspelo, poskusi znova.",

  "provider.stripe": "💳 Kartica (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Izbrana država",
  "panel.currentlyRanked": "Trenutno na #{rank}. mestu",
  "panel.shareCopied": "Kopirano ✓",
  "panel.shareShared": "Deljeno ✓",
  "panel.shareButton": "🔗 Deli",

  "panel.tableClicks": "Kliki",
  "panel.tableFree": "Brezplačni",
  "panel.tablePaid": "Plačani",
  "panel.rowAllTime": "Skupaj",
  "panel.rowThisYear": "Letos",
  "panel.rowThisWeek": "Ta teden",
  "panel.rowToday": "Danes",

  "panel.totalCombined": "Skupaj vse:",
  "panel.totalSupport": "Skupna podpora:",

  "panel.paymentMethod": "Način plačila",
  "panel.noPaymentMethod": "Trenutno ni na voljo noben način plačila.",
  "panel.supportAmount": "Znesek podpore (EUR)",
  "panel.amountRange": "Znesek naj bo med {min} in {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Ocenjeni plačani kliki:",
  "panel.ratioInfo":
    "Razmerje: {a} = {b} klikov (npr. {c} = {d} klikov). To je le ocena pred plačilom - končno število klikov vedno izračuna in potrdi strežnik na podlagi dejansko potrjenega plačila.",
  "panel.preparing": "Pripravljanje …",
  "panel.continueWith": "Nadaljuj z {provider}",
  "panel.choosePaymentMethod": "Izberi način plačila",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME ni nastavljen - za nastavitev glej README.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID ni nastavljen - za nastavitev glej README.",

  "panel.paypalAmountInfo": "Znesek: {amount} (ocenjeno {clicks} klikov). Plačilo dokončaj s spodnjim gumbom PayPal.",
  "panel.back": "← Nazaj",

  "panel.bmcWarningTitle": "⚠️ Preden nadaljuješ na BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Spodnjo kodo prilepi v polje za sporočilo/opombo ob plačilu — le tako bomo vedeli, katero državo podpiraš. Brez kode plačila ne moremo pripisati nobeni državi.",
  "panel.copy": "Kopiraj",
  "panel.copied": "Kopirano ✓",
  "panel.suggestedAmount": "Predlagani znesek:",
  "panel.bmcAmountNote":
    "(ocenjeno {clicks} klikov). BuyMeCoffee žal ne podpira prenosa zneska prek povezave — vnesi/izberi ga sam na njihovi strani. Dejansko število klikov se vedno izračuna iz zneska, ki ga dejansko pošlješ na BuyMeCoffee, ne iz te ocene.",
  "panel.openBmc": "Odpri BuyMeCoffee in nadaljuj →",
  "panel.waitingProvider": "Čakanje na potrditev plačila ponudnika …",
  "panel.waitingConfirmation": "Čakanje na potrditev plačila …",
  "panel.timedOut":
    "Preverjanje je poteklo. Če si plačilo zaključil, se bo zemljevid posodobil takoj, ko strežnik prejme potrditev - to lahko včasih traja malo dlje.",
  "panel.checkAgain": "Preveri znova",

  "panel.cancelled": "Plačilo je bilo preklicano ali ni uspelo. Zemljevid se ni spremenil.",
  "panel.tryAgain": "Poskusi znova",

  "panel.confirmed": "✅ Podpora potrjena!",
  "panel.confirmedBody": "Za {country} je zabeleženih {clicks} plačanih klikov v vrednosti {amount}.",

  "panel.errorPreparingSupport": "Napaka pri pripravi tvoje podpore.",
  "panel.errorPreparingPayment": "Napaka pri pripravi plačila.",
  "panel.errorConfirmingPayment": "Napaka pri potrjevanju plačila.",
  "panel.errorPayingPaypal": "Napaka pri plačilu s PayPal.",

  "share.unranked": "{flag}{country} potrebuje tvojo podporo na zemljevidu sveta!\nPomagaj ji splezati po lestvici 👇",
  "share.rank1": "{flag}{country} je trenutno na #1. mestu!\nPomagaj nam ostati na vrhu 👇",
  "share.rankN": "{flag}{country} je trenutno na #{rank}. mestu!\nPomagaj nam priti do #1 👇",

  "language.switcherLabel": "Jezik",
};

export default sl;
